import { atom } from 'recoil';

import { localStorage } from '@gitbook/util-local-storage';
/**
 * Whether the mobile sidebar is opened or not.
 */
export const onboardingSkippedAtom = atom<boolean>({
    key: 'homeOnboardingSkippedAtom',
    default: false,
    effects: [localStorage.recoilEffect('@recoil/homeOnboardingSkippedAtom', false)],
});
